import folderIcon from "../../../../../assets/management/folder.svg";
import phoneIcon from "../../../../../assets/shared/phone.svg";
import {
  ManageEntitiesActionType,
  useManageEntitiesContext,
} from "../../../../../context/ManageEntitiesContext";
import useResponsive from "../../../../../hooks/useResponsive";
import {
  IEntitiesTreeItem,
  State,
} from "../../../../../models/entity.interface";
import { isNumber } from "../../../../../utils/sharedUtil";
import { BaseIcon } from "@shltelemedicine/shl-ui-lib";
import EmailLink from "../../../../Shared/EmailLink/EmailLink";
import NoDataIndicator from "../../../../Shared/NoDataIndicator/NoDataIndicator";
import UsersCount from "../../../ManagementHeader/UsersCount/UsersCount";
import EntityActions from "../EntityActions/EntityActions";
import styles from "./TreeEntity.module.css";

type TreeEntityProps = {
  item: IEntitiesTreeItem;
  hideAdd?: boolean;
  hideEdit?: boolean;
  hideDelete?: boolean;
};

const TreeEntity = ({
  item,
  hideAdd,
  hideEdit,
  hideDelete,
}: TreeEntityProps) => {
  const { dispatch } = useManageEntitiesContext();

  const {
    name,
    email,
    phone,
    reference,
    state,
    activeUsers,
    totalUsers,
  } = item;

  const { isTabletPortrait } = useResponsive();

  const inactiveUsers =
    isNumber(totalUsers) && isNumber(activeUsers)
      ? totalUsers! - activeUsers!
      : undefined;

  const addEntityClickedHandler = () => {
    setSelectedEntity();

    dispatch({
      type: ManageEntitiesActionType.SET_ENTITY_MODAL,
      payload: {
        show: true,
        mode: "add",
      },
    });
  };

  const editEntityClickedHandler = () => {
    setSelectedEntity();

    dispatch({
      type: ManageEntitiesActionType.SET_ENTITY_MODAL,
      payload: {
        show: true,
        mode: "edit",
      },
    });
  };

  const deleteEntityClickedHandler = () => {
    setSelectedEntity();
    dispatch({
      type: ManageEntitiesActionType.SET_DELETE_ENTITY_MODAL,
      payload: true,
    });
  };

  const setSelectedEntity = () => {
    dispatch({
      type: ManageEntitiesActionType.SET_SELECTED_ENTITY,
      payload: item,
    });
  };

  return (
    <>
      <div className="d-flex algin-items-center">
        <BaseIcon icon={folderIcon} className={`${styles.folderIcon} mx-sm`} />
        <span className="mx-1"></span>
        <span className={`${styles.name} cut-text`}>{name}</span>
      </div>
      <div className="d-flex flex-grow-1 justify-content-end text-center">
        <span className={`${styles.email} `}>
          <EmailLink email={email ?? ""} />
        </span>
        <span className="mx-sm"></span>
        <h5 className={`${styles.phone} ${isTabletPortrait && "h6"}  mb-0`}>
          <div className="d-flex align-items-center">
            <BaseIcon icon={phoneIcon} className={styles.phoneIcon} />
            <span className="mx-1"></span>
            <span className="cut-text">{phone ?? <NoDataIndicator />}</span>
          </div>
        </h5>
        <span className="mx-sm"></span>
        <span className={`${styles.state} cut-text`}>
          {State[(state as unknown) as keyof typeof State]}
        </span>
        <span className="mx-sm"></span>
        <span className={`${styles.reference} cut-text`}>{reference}</span>
        <span className="mx-sm"></span>
      </div>
      <div
        className={`${styles.actions} d-flex align-items-center justify-content-end`}
      >
        <UsersCount
          total={totalUsers}
          active={activeUsers}
          inactive={inactiveUsers}
        />
        <div className="mx-2"></div>
        <EntityActions
          onAddEntity={addEntityClickedHandler}
          onEditEntity={editEntityClickedHandler}
          onDeleteEntity={deleteEntityClickedHandler}
          hideDelete={
            hideDelete || item.childNodes?.length !== 0 || item.totalUsers !== 0
          }
          hideEdit={hideEdit}
          hideAdd={hideAdd}
        />
      </div>
    </>
  );
};

export default TreeEntity;
